import { render, staticRenderFns } from "./RenderCargaDanfe.vue?vue&type=template&id=63d5d067&scoped=true"
import script from "./RenderCargaDanfe.vue?vue&type=script&lang=ts"
export * from "./RenderCargaDanfe.vue?vue&type=script&lang=ts"
import style0 from "./RenderCargaDanfe.vue?vue&type=style&index=0&id=63d5d067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d5d067",
  null
  
)

export default component.exports